import styled from 'styled-components';
import { Fragment } from 'react';

import { IRobotAsset } from 'shared/types/RobotAsset';
import { RobotImageExpandedView } from 'productTemplate/components/robotGallery/RobotImageExpandedView';
import { RobotVideoExpandedView } from 'productTemplate/components/robotGallery/RobotVideoExpandedView';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.robotGallery.RobotExpandedView';

interface IRobotExpandedView {
  expandedImagesUrls: IRobotAsset[];
  productName: string;
  setZoomedInRobot: (val) => void;
  zoomedInRobot: string;
}

export const RobotExpandedView = ({
  expandedImagesUrls,
  productName,
  setZoomedInRobot,
  zoomedInRobot,
}: IRobotExpandedView) => {
  const handleImageClick = (url) => {
    const isZoomedInRobotClicked = url === zoomedInRobot;
    return isZoomedInRobotClicked ? setZoomedInRobot(null) : setZoomedInRobot(url);
  };

  const expandedImagesCount =
    expandedImagesUrls.length + expandedImagesUrls.filter((image) => image.backUrl).length;

  return (
    <RobotExpandedView.Wrapper
      data-qa="robot_image_expanded_view"
      $imageWidth={100 / expandedImagesCount}
    >
      {expandedImagesUrls.map((expandedImage) => (
        <Fragment key={expandedImage.url}>
          {expandedImage.webmUrl || expandedImage.movUrl ? (
            <RobotVideoExpandedView
              handleOnClick={() => handleImageClick(expandedImage.url)}
              isZoomedIn={zoomedInRobot === expandedImage.url}
              webmUrl={expandedImage.webmUrl}
              movUrl={expandedImage.movUrl}
              posterImg={expandedImage.url}
              expandedCount={expandedImagesCount}
            />
          ) : (
            <>
              <RobotImageExpandedView
                alt={t(
                  `${TP}.robotImageExpandedViewAlt`,
                  'Model wearing {productName} expanded view',
                  { productName },
                )}
                handleOnClick={() => handleImageClick(expandedImage.url)}
                url={expandedImage.url}
                isZoomedIn={zoomedInRobot === expandedImage.url}
              />
              {expandedImage.backUrl && (
                <RobotImageExpandedView
                  alt={t(
                    `${TP}.robotImageExpandedBackView`,
                    'Model wearing {productName} expanded back view',
                    { productName },
                  )}
                  handleOnClick={() => handleImageClick(expandedImage.backUrl)}
                  url={expandedImage.backUrl}
                  isZoomedIn={zoomedInRobot === expandedImage.backUrl}
                />
              )}
            </>
          )}
        </Fragment>
      ))}
    </RobotExpandedView.Wrapper>
  );
};

RobotExpandedView.Wrapper = styled.div<{ $imageWidth: number }>`
  height: calc(100vh - 214px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.brandOverlay};
  max-width: 100vw;

  @media (max-height: 750px) {
    height: 100%;
  }

  img {
    max-height: min(100%, 750px);
    padding: 6px;
    width: auto;
    max-width: ${({ $imageWidth }) => ` ${$imageWidth}vw;`};
  }
`;
